<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="surveyStatus" @change="getSurveyList(true)" :disabled="loading" size="sm")
            option(:value="null") {{ $t('ui.all') }}
            option(:value="true") {{ $t('ui.active') }}
            option(:value="false") {{ $t('ui.inactive') }}
      .form-group.col-6.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getSurveyList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isEditAccess")
        b-button(v-b-modal.addSurvey type="button" variant="primary" size="sm" :disabled="loading").mr-3
          i.fa.fa-plus
          span {{ $t("ui.combine.add_survey") }}

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(width="5%")
                  span #
                th(width="20%")
                  span(:title="$t('ui.question')") {{ $t('ui.question') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th(width="10%")
                  span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                th(width="10%")
                  span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_on')") {{ $t("ui.modified_on") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_on')") {{ $t("ui.created_on") }}
            tbody.clusterize-content
              tr(v-if="surveyList.length == 0")
                td(colspan="7").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in surveyList")
                td
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.question") {{ item.question }}
                td.text-center
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedSurveyStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator

                td
                  span(:title="item.created_by") {{ item.created_by }}
                td
                  span(:title="item.modified_by") {{ item.modified_by }}
                td.text-right
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.modified_date") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    addSurvey(@clicked="afterAddSurvey" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addSurvey from "@/components/review/addSurvey.vue"

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addSurvey
  },
  data: () => ({
    loading: false,
    reviewList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "created_date",
    sortType: "desc",
    surveyStatus: true,
    surveyList: []
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_review");
    },
    canReply() {
      return true;
    }
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      this.getSurveyList(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getSurveyList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getSurveyList: function(isSearch) {
      let url = config.surveyListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        survey_status: this.surveyStatus,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.surveyList = response.data.dt;
                this.totalRow = this.surveyList.length > 0 ? this.surveyList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedSurveyStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.update_survey_status_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSurveyStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmSurveyStatus: function(item, status) {
      let url = config.surveyStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        survey_id: item.id,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getSurveyList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterAddSurvey: function() {
      this.getSurveyList();
      this.$helpers.showDialog(this.$t("ui.combine.add_survey"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSurveyList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSurveyList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>